import api from './api';
import store from '../store';


class ProjectService {

    search(input) {
        return api
            .post("/project/search", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }

    get(input) {
        return api
            .post("/project/get", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }

    saveProject(input) {
        return api
            .post("/project/save-project", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }

    deleteProject(input) {
        return api
            .post("/project/delete-project", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }

    saveVehiclesToProject(input) {
        return api
            .post("/project/save-vehicles-to-project", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }

    deleteProjectVehicles(input) {
        return api
            .post("/project/delete-project-vehicles", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }


    saveProjectUserTask(input) {
        return api
            .post("/project/save-project-user-task", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }


    deleteProjectUserTask(input) {
        return api
            .post("/project/delete-project-user-task", input)
            .then((response) => response.data)
            .catch((error) => {
                store.dispatch('error', error);
                return {};
            });
    }
}

export default new ProjectService();
